import { Formik } from "formik";
import { Button, buttonVariants } from "@/components/ui/button";
import { DialogClose } from "@/components/ui/dialog";
import { CustomInput } from "@/components";
import * as Yup from "yup";
import { showSuccessToast } from "@/lib/toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateClassLevel } from "@/api/common";
import { SelectOption } from "@/components/CustomSelect";

type EditLevelProps = {
  closeModal: () => void;
  levels: SelectOption[];
  level_id: string
};

const EditLevel = ({ closeModal, levels, level_id }: EditLevelProps) => {
  const queryClient = useQueryClient();

  const classLevel = levels?.find(({ value }) => value === level_id)

  const initialValues = {
    id: classLevel?.value ?? "",
    name: classLevel?.label ?? "",
  };
  const validationSchema = Yup.object().shape({
    id: Yup.string(),
    name: Yup.string().required("This field is required"),
  });

  const { mutate, isLoading } = useMutation(updateClassLevel,
    {
      onSuccess: ({ message }) => {
        showSuccessToast("Level edited successfully");
        queryClient.invalidateQueries({ queryKey: ["class-levels"] });
        queryClient.invalidateQueries({ queryKey: ["classes"] });
        closeModal();
      },
    },
  );

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => mutate(values)}
    >
      {({ values, handleChange, handleSubmit }) => (
        <form
          className="flex flex-col justify-between flex-grow h-full gap-6 pb-8"
          onSubmit={handleSubmit}
        >
          <CustomInput
            label="Level name"
            id="name"
            name="name"
            placeholder="Enter Level Name"
            value={values.name}
            onChange={handleChange}
          />
          <div className="flex items-center justify-end w-full gap-2">
            <DialogClose
              type="button"
              className={buttonVariants({ variant: "outline" })}
            >
              Cancel
            </DialogClose>
            <Button disabled={isLoading} className="min-w-[100px]">
              Submit
            </Button>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default EditLevel;
